import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class CouponService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }

    async couponsReport() {
        const data = {};
        const pos = getPosition();
        const response = await API.service('couponsReport', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async couponsPartnerCreate(data) {
        const pos = getPosition();
        const response = await API.service('couponsPartnerCreate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async couponsPartnerPending(data) {
        const pos = getPosition();
        const response = await API.service('couponsPartnerPending', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async couponsPartnerReassign(data) {
        const pos = getPosition();
        const response = await API.service('couponsPartnerReassign', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    async couponsPartnerBatchReAssign(data) {
        const pos = getPosition();
        const response = await API.service('couponsPartnerBatchReAssign', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}